export default {"src":"/_next/static/media/comeOn.eca68d1c.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};